/* CPPerformance homepage, header and mobile flow — conversion upgrade */
(function () {
  let montageNode = null;
  let montageMarker = null;

  function elementFromHTML(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function getHomepageBestsellersSection() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return null;
    const productList = main.querySelector('[data-testid="product-list"]');
    return productList && productList.closest('.shopify-section');
  }

  function mountHomepageQuickNav() {
    const main = document.querySelector("main[data-template='index']");
    if (!main || main.querySelector('.cp-home-quicknav')) return;

    const trust = main.querySelector('.cp-trust');
    const trustSection = trust && trust.closest('.shopify-section');
    if (!trustSection) return;

    const nav = elementFromHTML(`
      <nav class="cp-home-quicknav" aria-label="Snel naar populaire categorieën">
        <div class="cp-home-quicknav__inner">
          <span class="cp-home-quicknav__label">Snel naar</span>
          <div class="cp-home-quicknav__links">
            <a href="/collections/uitlaat-systemen">Uitlaatsystemen</a>
            <a href="/collections/downpipe">Downpipes</a>
            <a href="/collections/bodykits">Bodykits</a>
            <a href="/collections/apex-aero-design">APEX Aero</a>
            <a href="/#montage-afspraak">Montage</a>
            <a class="cp-home-quicknav__all" href="/collections/all">Alle onderdelen →</a>
          </div>
        </div>
      </nav>
    `);

    trustSection.insertAdjacentElement('afterend', nav);
  }

  function markHomepageBestsellers() {
    const section = getHomepageBestsellersSection();
    if (!section) return;
    section.classList.add('cp-bestsellers-home');

    const heading = section.querySelector('h2');
    if (heading && !section.querySelector('.cp-bestsellers-eyebrow')) {
      heading.insertAdjacentElement('beforebegin', elementFromHTML('<span class="cp-bestsellers-eyebrow">CPPerformance favorieten</span>'));
    }

    const headerArea = heading && (heading.closest('.group-block') || heading.parentElement);
    if (headerArea && !section.querySelector('.cp-bestsellers-meta')) {
      headerArea.appendChild(elementFromHTML('<div class="cp-bestsellers-meta"><span>Veelgekozen upgrades</span><span>Pasvormcheck mogelijk</span><span>Montage in Nederweert</span></div>'));
    }
  }

  function mountMontageAfterBestsellers() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return;

    const section = getHomepageBestsellersSection();
    const candidate = document.getElementById('montage-afspraak');
    const marker = document.querySelector('[data-cp-montage-source]');
    if (!section || !candidate || !marker) return;

    montageNode = candidate;
    montageMarker = marker;

    if (section.nextElementSibling !== candidate) {
      section.insertAdjacentElement('afterend', candidate);
    }
    document.documentElement.classList.add('cp-montage-raised');
  }

  function markBestsellersCollection() {
    const main = document.querySelector("main[data-template^='collection']");
    if (!main) return;

    const path = window.location.pathname.replace(/\/+$/, '');
    if (path !== '/collections/bestsellers') return;

    main.classList.add('cp-bestsellers-page');

    const heading = main.querySelector('h1');
    if (heading && !main.querySelector('.cp-bestsellers-page__eyebrow')) {
      heading.insertAdjacentElement('beforebegin', elementFromHTML('<span class="cp-bestsellers-page__eyebrow">CPPerformance • Bestsellers</span>'));
    }

    const intro = main.querySelector('.cp-collection-intro');
    if (intro && !intro.querySelector('.cp-bestsellers-page__lead')) {
      const lead = elementFromHTML('<div class="cp-bestsellers-page__lead"><strong>Onze veelgekozen performance & styling upgrades.</strong><span>Niet zeker van de pasvorm? Gebruik de Vehicle Finder of vraag ons om een controle. Montage is mogelijk op afspraak in Nederweert.</span></div>');
      const text = intro.querySelector('.cp-collection-intro__text');
      if (text) text.insertAdjacentElement('beforebegin', lead);
      else intro.insertAdjacentElement('afterbegin', lead);
    }
  }

  function mountDrawerShortcuts() {
    document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
      if (drawer.querySelector('.cp-drawer-shortcuts')) return;
      const menu = drawer.querySelector('.menu-drawer__menu');
      if (!menu) return;

      const shortcuts = elementFromHTML(`
        <nav class="cp-drawer-shortcuts" aria-label="Snel naar">
          <span class="cp-drawer-shortcuts__label">Snel naar</span>
          <div class="cp-drawer-shortcuts__grid">
            <a href="/collections/uitlaat-systemen">Uitlaatsystemen</a>
            <a href="/collections/downpipe">Downpipes</a>
            <a href="/collections/bodykits">Bodykits</a>
            <a href="/#montage-afspraak">Montage</a>
          </div>
          <a class="cp-drawer-shortcuts__help" href="/pages/contact">Hulp bij kiezen? Vraag advies →</a>
        </nav>
      `);

      menu.insertAdjacentElement('afterend', shortcuts);
    });
  }

  function markHeader() {
    const header = document.querySelector('#header-group');
    if (header) header.classList.add('cp-header-upgrade');
  }

  function restoreHomepageMoves(event) {
    if (
      montageNode &&
      montageMarker &&
      event.target &&
      event.target.contains(montageMarker) &&
      document.documentElement.contains(montageMarker)
    ) {
      montageMarker.insertAdjacentElement('afterend', montageNode);
      document.documentElement.classList.remove('cp-montage-raised');
    }
  }

  function mountAll() {
    mountHomepageQuickNav();
    markHomepageBestsellers();
    mountMontageAfterBestsellers();
    markBestsellersCollection();
    mountDrawerShortcuts();
    markHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:unload', restoreHomepageMoves);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._cpHomeTimer);
    observer._cpHomeTimer = window.setTimeout(function () {
      mountHomepageQuickNav();
      markHomepageBestsellers();
      mountMontageAfterBestsellers();
      markBestsellersCollection();
      mountDrawerShortcuts();
      markHeader();
    }, 120);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
